import React from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Text,
} from "@chakra-ui/react";
import { ACTION_CONSTANTS } from "@root/components/assessments/actionConstants";
import { useTranslation } from "react-i18next";

interface DeleteAssessmentModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void> | void;
  isLoading?: boolean;
  title?: string;
  message?: string;
  assessmentName?: string;
}

const DeleteAssessmentModal: React.FC<DeleteAssessmentModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  isLoading = false,
  title = "Delete Assessment",
  message = "Are you sure you want to delete this assessment?",
  assessmentName,
}) => {
  const { t } = useTranslation("common");
  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent borderRadius="12px" bg="white">
        <ModalHeader>{t("assessments.delete.title")}</ModalHeader>
        <ModalBody>
          <Text fontSize="14px" color="#4B5563">
            {assessmentName ? (
              <>
                {t("assessments.delete.messagePrefix")}{" "}
                <Text as="span" fontWeight="600">
                  {assessmentName}
                </Text>{" "}
                {t("assessments.delete.messageSuffix")}
              </>
            ) : (
              t("assessments.delete.defaultMessage")
            )}
          </Text>
        </ModalBody>
        <ModalFooter>
          <Button
            borderRadius="10px"
            border="1px solid #E5E7EB"
            variant="ghost"
            mr={3}
            onClick={onClose}
            isDisabled={isLoading}
            width={"100px"}
            size={ACTION_CONSTANTS.pending.size}
          >
            {t("assessments.delete.cancel")}
          </Button>
          <Button
            borderRadius="10px"
            onClick={onConfirm}
            isLoading={isLoading}
            width={"100px"}
            size={ACTION_CONSTANTS.pending.size}
            bg={ACTION_CONSTANTS.pending.hoverBg}
            color={ACTION_CONSTANTS.pending.hoverColor}
            _hover={{ bg: ACTION_CONSTANTS.pending.hoverBg }}
          >
            {t("assessments.delete.confirm")}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default DeleteAssessmentModal;
